import { render, staticRenderFns } from "./EditLanguageModal.vue?vue&type=template&id=29d033d6&"
import script from "./EditLanguageModal.vue?vue&type=script&lang=js&"
export * from "./EditLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports